module.exports = __webpack_public_path__ + "static/media/CT_2019_30441_8746.131f9fa9.png";